import React, { useState } from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  Card,
  CardContent,
  Button,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  ExpandMore as ExpandMoreIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Help as HelpIcon,
  BugReport as BugIcon,
  School as SchoolIcon,
  Security as SecurityIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Support = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  const handleInputChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({ ...prev, [field]: e.target.value }));
  };

  const faqs = [
    {
      question: "LGSCİYİZ uygulaması nasıl çalışır?",
      answer: "LGSCİYİZ, her gün yeni LGS soruları sunar. Soruları çözerek puan kazanır, diğer öğrencilerle yarışırsınız. Performansınızı takip edebilir ve zayıf olduğunuz konuları görebilirsiniz."
    },
    {
      question: "Uygulama ücretsiz mi?",
      answer: "Uygulamanın temel özellikleri ücretsizdir. Premium özellikler için aylık abonelik seçenekleri mevcuttur."
    },
    {
      question: "Hangi derslerde sorular var?",
      answer: "Matematik, Fen Bilimleri, Türkçe, Sosyal Bilgiler ve İngilizce derslerinde günlük sorular bulunmaktadır."
    },
    {
      question: "Sıralama sistemi nasıl çalışır?",
      answer: "Doğru cevapladığınız her soru için puan kazanırsınız. Bu puanlar toplanarak genel sıralamanız belirlenir. Sıralama gerçek zamanlı olarak güncellenir."
    },
    {
      question: "Hesabımı nasıl silebilirim?",
      answer: "Hesabınızı silmek için uygulama içindeki Profil > Ayarlar > Hesabı Sil seçeneğini kullanabilir veya destek ekibimizle iletişime geçebilirsiniz."
    },
    {
      question: "Teknik sorun yaşıyorum, ne yapmalıyım?",
      answer: "Teknik sorunlar için önce uygulamayı yeniden başlatmayı deneyin. Sorun devam ederse, aşağıdaki iletişim formunu kullanarak bize ulaşın."
    }
  ];

  const supportCategories = [
    {
      icon: <HelpIcon sx={{ fontSize: 40, color: '#3B82F6' }} />,
      title: 'Genel Sorular',
      description: 'Uygulama kullanımı ve özellikler hakkında',
      color: '#3B82F6'
    },
    {
      icon: <BugIcon sx={{ fontSize: 40, color: '#EF4444' }} />,
      title: 'Teknik Destek',
      description: 'Hata raporları ve teknik sorunlar',
      color: '#EF4444'
    },
    {
      icon: <SchoolIcon sx={{ fontSize: 40, color: '#10B981' }} />,
      title: 'Eğitim İçeriği',
      description: 'Sorular ve eğitim materyalleri',
      color: '#10B981'
    },
    {
      icon: <SecurityIcon sx={{ fontSize: 40, color: '#F59E0B' }} />,
      title: 'Hesap Güvenliği',
      description: 'Hesap ve gizlilik konuları',
      color: '#F59E0B'
    }
  ];

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc', py: 4 }}>
      <Container maxWidth="lg">
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/')}
          sx={{ mb: 3, color: '#4338CA' }}
        >
          Ana Sayfaya Dön
        </Button>

        {/* Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 2, color: '#1e293b' }}>
            Destek Merkezi
          </Typography>
          <Typography variant="h6" sx={{ color: '#64748b', maxWidth: 600, mx: 'auto' }}>
            Size nasıl yardımcı olabiliriz? Sorularınız için buradayız.
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
          {/* Left Column - Contact Info & Categories */}
          <Box sx={{ flex: { xs: 1, md: '0 0 33%' } }}>
            {/* Contact Information */}
            <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 3, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
                İletişim Bilgileri
              </Typography>

              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <EmailIcon sx={{ color: '#4338CA', mr: 2 }} />
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>E-posta</Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>fikirlerfikirler@gmail.com</Typography>
                </Box>
              </Box>

              {/*
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <PhoneIcon sx={{ color: '#4338CA', mr: 2 }} />
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>Telefon</Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>+90 (XXX) XXX XX XX</Typography>
                </Box>
             </Box>
             */}

              <Typography variant="body2" sx={{ color: '#64748b', mt: 2 }}>
                Destek saatleri: Pazartesi - Cuma, 09:00 - 18:00
              </Typography>
            </Paper>

            {/* Support Categories */}
            <Paper elevation={0} sx={{ p: 3, borderRadius: 3, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
                Destek Kategorileri
              </Typography>

              {supportCategories.map((category, index) => (
                <Card key={index} sx={{ mb: 2, border: `1px solid ${category.color}20` }}>
                  <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                      <Box sx={{
                        p: 1,
                        borderRadius: 2,
                        backgroundColor: `${category.color}15`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        {category.icon}
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                          {category.title}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.875rem' }}>
                          {category.description}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Paper>
          </Box>

          {/* Right Column - FAQ & Contact Form */}
          <Box sx={{ flex: { xs: 1, md: '0 0 67%' } }}>
            {/* FAQ Section */}
            <Paper elevation={0} sx={{ p: 4, mb: 4, borderRadius: 3, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
                Sık Sorulan Sorular
              </Typography>

              {faqs.map((faq, index) => (
                <Accordion key={index} sx={{ mb: 1, '&:before': { display: 'none' } }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" sx={{ color: '#4b5563', lineHeight: 1.6 }}>
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Paper>

            {/* Contact Form */}
            <Paper elevation={0} sx={{ p: 4, borderRadius: 3, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
                Bize Ulaşın
              </Typography>

              {submitted && (
                <Alert severity="success" sx={{ mb: 3 }}>
                  Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.
                </Alert>
              )}

              <form onSubmit={handleSubmit}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3 }}>
                    <TextField
                      fullWidth
                      label="Ad Soyad"
                      value={formData.name}
                      onChange={handleInputChange('name')}
                      required
                    />
                    <TextField
                      fullWidth
                      label="E-posta"
                      type="email"
                      value={formData.email}
                      onChange={handleInputChange('email')}
                      required
                    />
                  </Box>
                  <TextField
                    fullWidth
                    label="Konu"
                    value={formData.subject}
                    onChange={handleInputChange('subject')}
                    required
                  />
                  <TextField
                    fullWidth
                    label="Mesajınız"
                    multiline
                    rows={4}
                    value={formData.message}
                    onChange={handleInputChange('message')}
                    required
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{
                      backgroundColor: '#4338CA',
                      '&:hover': { backgroundColor: '#3730A3' },
                      px: 4,
                      py: 1.5,
                      fontWeight: 600,
                      alignSelf: 'flex-start'
                    }}
                  >
                    Mesaj Gönder
                  </Button>
                </Box>
              </form>
            </Paper>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Support;